import { render, staticRenderFns } from "./ShopProductDetail.vue?vue&type=template&id=2bc87c90&scoped=true&"
import script from "./ShopProductDetail.vue?vue&type=script&lang=js&"
export * from "./ShopProductDetail.vue?vue&type=script&lang=js&"
import style0 from "./ShopProductDetail.vue?vue&type=style&index=0&id=2bc87c90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bc87c90",
  null
  
)

export default component.exports